<template>
  <header
    :class="[
      $style.flexContainer,
      $style.attributesHeader,
      $style.sectionGeneralMargin,
    ]"
  >
    <div :class="$style.spAttributeHeader">
      Service provider attribute JSON path
    </div>
    <div :class="$style.appAttributeHeader">
      JumpCloud attribute
    </div>
    <div :class="$style.actions">
      <a
        :class="{[$style.disabled]: !enablePreview}"
        href="javascript:void(0);"
        @click="handlePreview"
      >
        Preview
      </a>
    </div>
  </header>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import { verifyTypes } from 'client/util/Constants/ApplicationConstants';

import IdmUserPreviewModal from 'client/components/Modal/IdmUserPreviewModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export default {
  name: 'AttributeMappingHeader',

  props: {
    enablePreview: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapActions(applicationModel, ['verifyScimConnection']),

    ...mapActions(notificationModule, [
      'triggerErrorNotification',
    ]),

    async handlePreview() {
      if (this.enablePreview) {
        try {
          const { test_schema: testSchema = {} } = await this.verifyScimConnection({
            type: verifyTypes.SCHEMA,
            saveErrors: true,
          });

          const {
            external: spUserSchema = {},
            internal: jcMappedSchema = {},
          } = testSchema;

          ModalEventBus.open({
            component: IdmUserPreviewModal,
            componentProps: { spUserSchema, jcMappedSchema },
          });
        } catch (e) {
          this.triggerErrorNotification({
            isMarkdown: true,
            message: 'An error occurred when attempting to preview the user schema. See the error message in the **User Schema Attribute Mapping** section for more details.',
            title: 'Preview failed',
          });
        }
      }
    },
  },
};
</script>

<style module>
@import '../css/IdentityManagementCommon.css';

@value (jcGrey300,jcGrey400) from '~css/brand-colors.css';

.actions {
  margin-left: auto;
}

.attributesHeader {
  border-bottom: 2px solid jcGrey300;
  font-weight: bold;
  margin-top: 2rem;
  padding-bottom: 0.5rem;
}

.attributesHeader > div:not(.actions) {
  margin-right: 20px;
}

.spAttributeHeader {
  width: 46.3%;
}

.appAttributeHeader {
  width: calc(100% - 46.3% - 140px);
}

.disabled {
  color: jcGrey400;
}
</style>
